<template>
  <div class="footer-container">
    <van-collapse v-model="activeNames">
      <van-collapse-item name="1">
        <template #title>
          <div>{{$t('300262')}}</div>
        </template>
        <ul>
          <li><a target="_blank"
                 :href="language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/articles/4413122414105' : language == 'ko' ? 'https://support.superex.com/hc/ko/articles/4413122441497' : 'https://support.superex.com/hc/en-001/articles/4413122427545'">{{$t('300263')}}</a>
          </li>
          <li><a target="_blank"
                 :href="language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/articles/11461213305625' : language == 'ko' ? 'https://support.superex.com/hc/ko/articles/11478725012761' : 'https://support.superex.com/hc/en-001/articles/11478863478809'">{{$t('300264')}}</a>
          </li>
          <li><a target="_blank"
                 :href="language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4410470420249' : language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4410470420249' : 'https://support.superex.com/hc/en-001/categories/4410470420249'">{{$t('300265')}}</a>
          </li>
        </ul>
      </van-collapse-item>
      <van-collapse-item name="2">
        <template #title>
          <div>{{$t('300266')}}</div>
        </template>
        <ul>
          <li><a
            :href="language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4412787796889-%E6%96%B0%E6%89%8B%E4%B8%AD%E5%BF%83' : language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4412787796889-%EC%B4%88%EB%B3%B4%EC%9E%90-%EC%95%84%EC%B9%B4%EB%8D%B0%EB%AF%B8' : 'https://support.superex.com/hc/en-001/categories/4412787796889-Beginner-s-Center'"
            target="_blank">{{$t('300267')}}</a></li>
          <li><a
            :href="language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4410478890137-%E7%8F%BE%E8%B2%A8-%E6%9D%A0%E6%9D%86%E4%BA%A4%E6%98%93' : language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4410478890137-%ED%98%84%EB%AC%BC-%EB%A0%88%EB%B2%84%EB%A6%AC%EC%A7%80-%EA%B1%B0%EB%9E%98' : 'https://support.superex.com/hc/en-001/categories/4410478890137-Spot-Leveraged-Trading'"
            target="_blank">{{$t('300268')}}</a></li>
          <li><a
            :href="language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4410478992793-%E5%90%88%E7%B4%84%E4%BA%A4%E6%98%93' : language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4410478992793-%EC%84%A0%EB%AC%BC-%EA%B1%B0%EB%9E%98' : 'https://support.superex.com/hc/en-001/categories/4410478992793-Futures-Trading'"
            target="_blank">{{$t('300269')}}</a></li>
          <li><a
            :href="language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4412774906905-%E5%B8%B8%E8%A6%8B%E5%95%8F%E9%A1%8C' : language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4412774906905-FAQ' : 'https://support.superex.com/hc/en-001/categories/4412774906905-FAQ'"
            target="_blank">{{$t('300270')}}</a></li>
        </ul>
      </van-collapse-item>
      <van-collapse-item name="3">
        <template #title>
          <div>{{$t('300271')}}</div>
        </template>
        <ul>
          <li><a @click="$router.push('/register')">{{$t('300272')}}</a></li>
          <li><a @click="$router.push('/register')">{{$t('300273')}}</a></li>
          <li><a
            :href="language == 'zh-TC' ? 'https://docs.google.com/forms/d/e/1FAIpQLSep8jqJSbo9fvN5F1YLYwyWzKaSGc3G_y6vzFfikvQTLcGLIQ/viewform' : language == 'ko' ? 'https://docs.google.com/forms/d/e/1FAIpQLSe-v5-CgXpFudeOf8jX_mtsQlXCez41e3AOvT-p8zFo64gY7g/viewform' : 'https://docs.google.com/forms/d/e/1FAIpQLSd0zIRGvBWB2Bv_fmiwqSMTx5vAcaPi7n443Jjj49UG8j-kOg/viewform'"
            target="_blank">{{$t('300274')}}</a></li>
          <li><a @click="$router.push('/register')">{{$t('300275')}}</a></li>
        </ul>
      </van-collapse-item>
      <van-collapse-item name="4">
        <template #title>
          <div>{{$t('300276')}}</div>
        </template>
        <ul>
          <li><a target="_blank"
                 :href="language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk' : language == 'ko' ? 'https://support.superex.com/hc/ko' : 'https://support.superex.com/hc/en-001' ">{{$t('300277')}}</a>
          </li>
          <li><a href="https://support.superex.com/hc/en-001/requests/new">{{$t('300278')}}</a></li>
          <li><a hhref="mailto:business@superex.com" target="_blank">{{$t('300279')}}</a></li>
          <li><a href="mailto:gbg@superex.com" target="_blank">{{$t('300280')}}</a></li>
        </ul>
      </van-collapse-item>
    </van-collapse>
    <div class="logo">
      <svg slot="image" class="icon" aria-hidden="true">
        <use xlink:href="#icon-logo1"/>
      </svg>
      <p>{{$t('300261')}}</p>
    </div>
    <div class="contacts-box flex-center">
      <div class="contact-item" @click="handleClick('twitter')" v-show="linksObj.twitter.length != 0">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-Twitter_gaoliang"/>
        </svg>
      </div>
      <div class="contact-item" @click="handleClick('telegram')" v-show="linksObj.telegram.length != 0">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-Telegram-gaoliang"/>
        </svg>
      </div>
      <div class="contact-item" @click="handleClick('medium')" v-show="linksObj.medium.length != 0">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-medium-1"/>
        </svg>
      </div>
      <div class="contact-item" @click="handleClick('INS')" v-show="linksObj.INS.length != 0">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-INS_gaoliang"/>
        </svg>
      </div>
      <div class="contact-item" @click="handleClick('Discord')" v-show="linksObj.Discord.length != 0">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-Discord-xuanzhong"/>
        </svg>
      </div>
      <div class="contact-item" @click="handleClick('YouTube')" v-show="linksObj.YouTube.length != 0">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-youtube_gaoliang"/>
        </svg>
      </div>
      <div class="contact-item" @click="handleClick('Facebook')" v-show="linksObj.Facebook.length != 0">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-facebook-gaoliang"/>
        </svg>
      </div>
      <div class="contact-item" @click="handleClick('CMC')" v-show="linksObj.CMC.length != 0">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-cmc_gaoliang"/>
        </svg>
      </div>
    </div>
    <div class="copyright">
      © 2023 SUPERDAO INC
    </div>
    <van-popup v-model="show" position="bottom">
      <div class="flex-between title">
        <span class="inline-block capitalize">{{activeType}}</span>
        <i class="iconfont icon-guanbi1" @click="show = false"></i>
      </div>
      <ul>
        <li v-for="item in resultList" :key="item.id" @click="goLink(item.url)">{{item.title}}</li>
      </ul>
    </van-popup>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {Collapse, CollapseItem,Popup} from 'vant';
import {linksApi} from "../api/resource";
import fa from "../i18n/langs/fa";

export default {
  name: "footerView",
  components: {
    vanCollapse: Collapse,
    vanCollapseItem: CollapseItem,
    vanPopup:Popup
  },
  data() {
    return {
      activeNames: [],
      linksObj: {
        twitter: [],
        telegram: [],
        medium: [],
        INS: [],
        Discord: [],
        YouTube: [],
        Facebook: [],
        CMC: []
      },
      show: false,
      resultList: [],
      activeType: ''
    }
  },
  computed: {
    ...mapGetters(['isDirection', 'language'])
  },
  created() {
    this.getLinksApi()
  },
  methods: {
    getLinksApi() {
      this.linksObj = {
        twitter: [],
        telegram: [],
        medium: [],
        INS: [],
        Discord: [],
        YouTube: [],
        Facebook: [],
        CMC: []
      }
      linksApi().then(res => {
        if (res.data) {
          res.data.forEach(v => {
            if (v.type == 1) {
              this.linksObj.twitter.push(v)
            } else if (v.type == 2) {
              this.linksObj.telegram.push(v)
            } else if (v.type == 3) {
              this.linksObj.medium.push(v)
            } else if (v.type == 4) {
              this.linksObj.INS.push(v)
            } else if (v.type == 5) {
              this.linksObj.Discord.push(v)
            } else if (v.type == 6) {
              this.linksObj.YouTube.push(v)
            } else if (v.type == 7) {
              this.linksObj.Facebook.push(v)
            } else if (v.type == 8) {
              this.linksObj.CMC.push(v)
            }else {
              return false
            }
          })
        }
      })
    },
    handleClick(type) {
      this.activeType = type
      if (this.linksObj[type].length == 0) {
        return false
      }else if (this.linksObj[type].length == 1) {
        window.open(this.linksObj[type][0].url)
        return false
      }else{
        this.show = true
        this.resultList = this.linksObj[type]
      }
    },
    goLink(url) {
      window.open(url)
      this.show = false
    }
  }
}
</script>
<style lang="scss">
@import "../style/mixin";
@import "../assets/css/variableName";
[dir='ltr'] .footer-container{
  .van-cell__title {
    padding-left: torem(7);
    border-left: torem(4) solid #FFC72B;
  }
}
[dir='rtl'] .footer-container{
  .van-cell__title {
    padding-right: torem(7);
    border-right: torem(4) solid #FFC72B;
  }
}
</style>
<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";

.footer-container {
  width: 100%;
  height: auto;
  background-color: #1B1C22;
  padding: torem(16);

  /deep/ .van-cell__title {
    font-size: torem(14);
    color: #FFFFFF;
    font-weight: bold;
  }

  /deep/ .van-cell {
    background: transparent;
    padding: torem(16) 0;
  }

  /deep/ .van-collapse-item__content {
    background: rgba(255, 255, 255, 0.06);
    border-radius: torem(4);
    padding: torem(8) torem(12);

    ul > li {
      padding: torem(12) 0;
      font-size: torem(14);
      color: rgba(255, 255, 255, 0.60);
    }
  }

  /deep/ .van-cell__right-icon {
    font-size: torem(14);
    color: #FFFFFF;
    font-weight: bold;
  }

  /deep/ .van-cell::after {
    border: none;
  }

  /deep/ .van-collapse-item--border::after {
    border: none;
  }

  /deep/ .van-hairline--top-bottom::after, /deep/ .van-hairline-unset--top-bottom::after {
    border: none;
  }

  .logo {
    margin-top: torem(25);

    svg.icon {
      width: torem(100);
      height: torem(16);
    }

    p {
      font-size: torem(12);
      color: rgba(255, 255, 255, 0.60);
      margin: torem(10) 0 torem(24);
    }
  }
  .contacts-box{
    margin-bottom: torem(24);
    .contact-item{
      svg{
        width: torem(18);
        height: torem(18);
        margin-right: torem(16);
      }
    }
  }
  .copyright{
    font-size: torem(12);
    color: rgba(255, 255, 255, 0.40);
    padding-top: torem(11);
    border-top: torem(1) solid rgba(255, 255, 255, 0.05);
    text-align: center;
  }
  /deep/ .van-popup{
    padding: torem(24) torem(16);
    border-radius: torem(8) torem(8) 0 0;
    .title{
      margin-bottom: torem(8);
      span{
        font-size: torem(16);
        color: #333333;
        font-weight: bold;
      }
      i{
        color: #666666;
        font-weight: normal;
      }
    }
    ul{
      max-height: torem(310);
      overflow-y: auto;
      li{
        padding: torem(24) torem(12);
        font-size: torem(14);
        color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/compontents/footerView.vue